module.exports = __webpack_public_path__ + "img/Yiming_Li.1d209360.png";